import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import Chart from 'chart.js/auto';
import { EventService } from 'src/app/services/event.service';

@Component({
    selector: 'app-res-equalizer-chart',
    templateUrl: './res-equalizer-chart.component.html',
    styleUrl: './res-equalizer-chart.component.scss',
    standalone: false
})
export class ResEqualizerChartComponent implements OnInit, OnDestroy {
	@Input() rgbData: any[] = [];

	private equalizerChart!: Chart;
  public equalizerData: number[] = [0, 0, 0];

	ready = false;
	lastCog = 0;
	lastEmo = 0;

	constructor(private eventService: EventService) {}

	ngOnInit(): void {
		this.eventService.subscribe('changeMode', (data) => {
			this.equalizerChart.options.scales = {
				y: {
					beginAtZero: true,
					max: 100,
					ticks: {
						color: data === 'dark' ? 'white' : 'black'
					}
				},
				x: {
					ticks: {
						color: data === 'dark' ? 'white' : 'black'
					}
				}
			};

			this.equalizerChart.update();
		});
		this.initialEqualizerData();
	}

	ngOnDestroy(): void {
    if (this.equalizerChart) {
      this.equalizerChart.destroy();
    }
	}

	showChart() {
		this.initialEqualizerData();
	}

	initialEqualizerData() {
		let cog = +(this.rgbData[0].cognitive);
		let emo = +(this.rgbData[0].emotional);

		const gs = +((cog + emo)/2).toFixed(2);

		this.equalizerData = [cog, emo, gs];
		
		const canvas = document.getElementById('equalizerCanvas') as HTMLCanvasElement;
		const ctx = canvas.getContext('2d');

		if (ctx) {
			const gradientHeight = canvas.height;
			const gradient = ctx.createLinearGradient(0, 0, 0, gradientHeight+100);
			gradient.addColorStop(0, 'rgba(255, 0, 0, 0.5)'); // Start color (red)
			gradient.addColorStop(0.5, 'rgba(255, 195, 0, 0.5)'); // Middle color (yellow)
			gradient.addColorStop(1, 'rgba(0, 255, 0, 0.5)'); // End color (green)

			this.equalizerChart = new Chart(ctx, {
				type: 'bar',
				data: {
					labels: ['Cognitive', 'Emotion', 'Stress'],
					datasets: [
						{
							label: 'Value',
							data: this.equalizerData,
							backgroundColor: gradient
						},
					]
				},
				options: {
					scales: {
						y: {
							beginAtZero: true,
							max: 100,
							ticks: {
								color: 'white'
							}
						},
						x: {
							ticks: {
								color: 'white'
							}
						}
					},
					plugins: {
						legend: {
							display: false
						},
					}
				}
			});
	
			if (!this.ready) {
				this.ready = true;
			}
		}
	}

	updateChart(currentTime: number) {
		let cog;
		let emo;

		if (currentTime < this.rgbData.length) {
			cog = +(this.rgbData[currentTime].cognitive);
			emo = +(this.rgbData[currentTime].emotional);

			this.lastCog = cog;
			this.lastEmo = emo;
		} else {
			cog = this.lastCog;
			emo = this.lastEmo;
		}
		
		const gs = +((cog + emo)/2).toFixed(2);
		this.equalizerData = [cog, emo, gs];

    this.equalizerChart.data.datasets[0].data = this.equalizerData;
    this.equalizerChart.update();
  }
}
